import { connectRouter } from 'connected-react-router';
import history from '../../utils/history';
import imagesReducer from '../slices/imagesSlice';
import editorReducer from '../slices/editorSlice';
import reportDataReducer from '../slices/reportSlice';
import columbiaReducer from '../slices/columbiaSlice';
import { combineReducers } from '@reduxjs/toolkit';

const router = connectRouter(history);

const reducer = combineReducers({
  images: imagesReducer,
  editorData: editorReducer,
  reportData: reportDataReducer,
  columbia: columbiaReducer,
});

export { router, reducer };
